import { appearenceSettings } from "../constants";

export const TYPES = {
  GET_BOOK_INFO: 'GET_BOOK_INFO',
  SET_BOOK_INFO: 'SET_BOOK_INFO',
  GET_BOOK_WITH_META: 'GET_BOOK_WITH_META',
  SET_BOOK_WITH_META: 'SET_BOOK_WITH_META',
  GET_NOTES: 'GET_NOTES',
  UPDATE_READ_POSITION: 'UPDATE_READ_POSITION',
  SET_CHAPTER_TITLE: 'SET_CHAPTER_TITLE',
  SET_CHAPTERS: 'SET_CHAPTERS',
  UPDATE_FAVORITE: 'UPDATE_FAVORITE',
  SET_FAVORITE: 'SET_FAVORITE',
  SET_HIGHLIGHTS: 'SET_HIGHLIGHTS',
  SET_BOOKMARKS: 'SET_BOOKMARKS',
  SET_PAGE_COUNT: 'SET_PAGE_COUNT',
  HIGHLIGHT_ACTION: 'HIGHLIGHT_ACTION',
  DELETE_NOTE: 'DELETE_NOTE',
  DELETE_HIGHLIGHT: 'DELETE_HIGHLIGHT',
  ADD_HIGHLIGHT: 'ADD_HIGHLIGHT',
  ADD_NOTE: 'ADD_NOTE',
  DELETE_BOOKMARK: 'DELETE_BOOKMARK',
  ADD_BOOKMARK: 'ADD_BOOKMARK',
  SET_DEFAULT_BOOK_FONT: 'SET_DEFAULT_BOOK_FONT',
  SET_APPEARENCE_TEXT_SIZE: 'SET_APPEARENCE_TEXT_SIZE',
  SET_APPEARENCE_TEXT_FONT: 'SET_APPEARENCE_TEXT_FONT',
  SET_APPEARENCE_TEXT_COLOR: 'SET_APPEARENCE_TEXT_COLOR',
  SET_APPEARENCE_TEXT_FLOW: 'SET_APPEARENCE_TEXT_FLOW',
  APPEARENCE_TEXT_SIZE: 'APPEARENCE_TEXT_SIZE',
  APPEARENCE_TEXT_FONT: 'APPEARENCE_TEXT_FONT',
  APPEARENCE_TEXT_COLOR: 'APPEARENCE_TEXT_COLOR',
  APPEARENCE_TEXT_FLOW: 'APPEARENCE_TEXT_FLOW',
  GET_APPEARENCE: 'GET_APPEARENCE',
  SET_BOOK_LOADING_PROGRESS: 'SET_BOOK_LOADING_PROGRESS',
  SET_CURR_PAGE: 'SET_CURR_PAGE',
  SET_OPEN_ADD_NOTE: 'SET_OPEN_ADD_NOTE',
  UPDATE_NOTE: 'UPDATE_NOTE',
  ON_UPDATE_NOTE: 'ON_UPDATE_NOTE',
  ON_SET_BASE_PARAMS: 'ON_SET_BASE_PARAMS',
  SET_URL_PARAMS: 'SET_URL_PARAMS',
  SET_BOOK_URL: 'SET_BOOK_URL',
  SET_BOOK_ID: 'SET_BOOK_ID',
  SET_BOOK_READY: 'SET_BOOK_READY',
  SET_PAGE_NUM_PENDING: 'SET_PAGE_NUM_PENDING',
  SET_PAGE_RENDERING: 'SET_PAGE_RENDERING',
  SET_FULLSCREEN_MODE: 'SET_FULLSCREEN_MODE',
  SET_IN_BOOKMARKS: 'SET_IN_BOOKMARKS',
  SET_EDIT_NOTE_TEXT: 'SET_EDIT_NOTE_TEXT',
  SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
  GET_PAGE: 'GET_PAGE',
  SET_PAGE_READY: 'SET_PAGE_READY',
  SET_CURR_CHAPTER: 'SET_CURR_CHAPTER',
  SET_SELECTION: 'SET_SELECTION',
  ADD_PREV_STATE: 'ADD_PREV_STATE',
  REMOVE_PREV_STATE: 'REMOVE_PREV_STATE',
  REPLACE_PREV_STATE: 'REPLACE_PREV_STATE',
  SET_SELECTED_NOTE: 'SET_SELECTED_NOTE',
  SET_SAMPLE_MODE: 'SET_SAMPLE_MODE'
}

export const onSetBaseParams = (params, path) => ({
  type: TYPES.ON_SET_BASE_PARAMS,
  payload: {
    params: params,
    path: path
  }
})

export const setUrlParams = (params) => ({
  type: TYPES.SET_URL_PARAMS,
  payload: params
})

export const setBookUrl = (url) => ({
  type: TYPES.SET_BOOK_URL,
  payload: url
})

export const setBookId = (id) => ({
  type: TYPES.SET_BOOK_ID,
  payload: id
})

export const setBookReady = (status) => ({
  type: TYPES.SET_BOOK_READY,
  payload: status
})

export const setPageReady = (status) => ({
  type: TYPES.SET_PAGE_READY,
  payload: status
})

export const getBookInfo = (bookId) => ({
  type: TYPES.GET_BOOK_INFO,
  payload: bookId
})

export const setBookInfo = (book) => ({
  type: TYPES.SET_BOOK_INFO,
  payload: book
})

export const getBookWithMeta = (bookId) => ({
  type: TYPES.GET_BOOK_WITH_META,
  payload: bookId
})

export const setBookWithMeta = (book) => ({
  type: TYPES.SET_BOOK_WITH_META,
  payload: book
})

export const getNotes = (id) => ({
  type: TYPES.GET_NOTES,
  payload: id
})

export const setBookMarks = (notes) => ({
  type: TYPES.SET_BOOKMARKS,
  payload: notes
})

export const setHighLights = (notes) => ({
  type: TYPES.SET_HIGHLIGHTS,
  payload: notes
})

export const updateReadPosition = (read_position, id) => ({
  type: TYPES.UPDATE_READ_POSITION,
  payload: {
    read_position: read_position,
    id: id
  }
})

export const setChapters = (chapters) => ({
  type: TYPES.SET_CHAPTERS,
  payload: chapters
})

export const updateFavorite = (status, id) => ({
  type: TYPES.UPDATE_FAVORITE,
  payload: {
    status,
    id
  }
})

export const setFavorite = ({status, id}) => ({
  type: TYPES.SET_FAVORITE,
  payload: {
    status: status,
    id
  }
})

export const setPageCount = (count) => ({
  type: TYPES.SET_PAGE_COUNT,
  payload: count
})

export const highlightAction = (status) => ({
  type: TYPES.HIGHLIGHT_ACTION,
  payload: status
})

export const deleteNote = ( id, path, isHighlight = false ) => ({
  type: TYPES.DELETE_NOTE,
  payload: {
    id: id,
    path: path,
    isHighlight: isHighlight
  }
})

export const addNote = (note, path, isHighlight = false) => ({
  type: TYPES.ADD_NOTE,
  payload: {
    note: note,
    path: path,
    isHighlight: isHighlight
  }
})

export const deleteHighlight = ({ id }) => ({
  type: TYPES.DELETE_HIGHLIGHT,
  payload: {
    uuid: id
  }
})

export const addHighlight = (note) => ({
  type: TYPES.ADD_HIGHLIGHT,
  payload: note
})

export const deleteBookmark = ({ id }) => ({
  type: TYPES.DELETE_BOOKMARK,
  payload: {
    uuid: id
  }
})

export const addBookmark = (note) => ({
  type: TYPES.ADD_BOOKMARK,
  payload: note
})

export const setDefaultBookFont = (font) => ({
  type: TYPES.SET_DEFAULT_BOOK_FONT,
  payload: font
})

export const getAppearence = () => ({
  type: TYPES.GET_APPEARENCE
})

export const setAppearenceTextSize = (size = appearenceSettings.size) => ({
  type: TYPES.SET_APPEARENCE_TEXT_SIZE,
  payload: size
})

export const setAppearenceTextColor = (color = appearenceSettings.color) => ({
  type: TYPES.SET_APPEARENCE_TEXT_COLOR,
  payload: color
})

export const setAppearenceTextFont = (font = appearenceSettings.font) => ({
  type: TYPES.SET_APPEARENCE_TEXT_FONT,
  payload: font
})

export const setAppearenceTextFlow = (flow = appearenceSettings.flow) => ({
  type: TYPES.SET_APPEARENCE_TEXT_FLOW,
  payload: flow
})

export const appearenceTextSize = (size = appearenceSettings.size) => ({
  type: TYPES.APPEARENCE_TEXT_SIZE,
  payload: size
})

export const appearenceTextColor = (color = appearenceSettings.color) => ({
  type: TYPES.APPEARENCE_TEXT_COLOR,
  payload: color
})

export const appearenceTextFont = (font = appearenceSettings.font) => ({
  type: TYPES.APPEARENCE_TEXT_FONT,
  payload: font
})

export const appearenceTextFlow = (flow = appearenceSettings.flow) => ({
  type: TYPES.APPEARENCE_TEXT_FLOW,
  payload: flow
})

export const setBookLoadingProgress = (progress) => ({
  type: TYPES.SET_BOOK_LOADING_PROGRESS,
  payload: progress
})

export const setCurrPage = (page) => ({
  type: TYPES.SET_CURR_PAGE,
  payload: page
})

export const setOpenAddNote = (status) => ({
  type: TYPES.SET_OPEN_ADD_NOTE,
  payload: status
})

export const updateNote = (id, note, path) => ({
  type: TYPES.UPDATE_NOTE,
  payload: {
    id: id,
    note: note,
    path: path
  }
})
export const onUpdateNote = (note) => ({
  type: TYPES.ON_UPDATE_NOTE,
  payload: note
})

export const setPageRendering = (status) => ({
  type: TYPES.SET_PAGE_RENDERING,
  payload: status
})

export const setPageNumPending = (num) => ({
  type: TYPES.SET_PAGE_NUM_PENDING,
  payload: num
})

export const setFullscreenMode = (status) => ({
  type: TYPES.SET_FULLSCREEN_MODE,
  payload: status
})

export const setInBookmarks = (status) => ({
  type: TYPES.SET_IN_BOOKMARKS,
  payload: status
})

export const setCurrChapter = (chapter) => ({
  type: TYPES.SET_CURR_CHAPTER,
  payload: chapter
})

export const setEditNoteText = (text) => ({
  type: TYPES.SET_EDIT_NOTE_TEXT,
  payload: text
})

export const setSearchResult = (result) => ({
  type: TYPES.SET_SEARCH_RESULT,
  payload: result
})

export const setSelection = (selection, date) => ({
  type: TYPES.SET_SELECTION,
  payload: {
    selection: selection,
    updated: date
  }
})

export const addPrevState = (page, location) => ({
  type: TYPES.ADD_PREV_STATE,
  payload: {
    page: page,
    location: location
  }
})

export const removePrevState = () => ({
  type: TYPES.REMOVE_PREV_STATE
})

export const replaceState = (state, index) => ({
  type: TYPES.REPLACE_PREV_STATE,
  payload: {
    state: state,
    index: index
  }
})

export const setSelectedNote = (note) => ({
  type: TYPES.SET_SELECTED_NOTE,
  payload: note
})

export const setSampleMode = (status) => ({
  type: TYPES.SET_SAMPLE_MODE,
  payload: status
})


// WEBPACK FOOTER //
// ./src/actions/reader.js